import React, { Fragment, useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { Menu } from "@mui/material";
import DateRangeComponent from "./dateRangePicker";
import styles from "./timepriod.module.scss";
import { timePeriods } from "@unisearch/helpers";
import moment from "moment-timezone";

export const TimePeriod = ({
  name = "timePriod",
  value,
  handleTimePeriod,
  ...props
}) => {
  const [timeState, setTimeState] = useState("All time periods");
  const [anchorElTime, setAnchorElTime] = useState(null);
  const openTime = Boolean(anchorElTime);
  const todayRange = `${moment().format("YYYY/MM/DD")} - ${moment().format(
    "YYYY/MM/DD"
  )}`;

  //Handle Date Selection
  const handleDateSelect = (name, data) => {
    if (handleTimePeriod) {
      handleTimePeriod({
        period: "custom",
        time: data,
      });
    }
  };

  const selectTimePriod = (item) => {
    setTimeState(item.title);

    let today = moment().format("YYYY/MM/DD");
    let yesterday = moment()
      .add(-1, "days")
      .format("YYYY/MM/DD");

    let sevenDays = moment()
      .add(-7, "days")
      .format("YYYY/MM/DD");

    let thirtyDays = moment()
      .add(-30, "days")
      .format("YYYY/MM/DD");

    let lastsevendays = `${sevenDays} - ${today}`;
    let lastthirtydays = `${thirtyDays} - ${today}`;

    if (handleTimePeriod) {
      if (item.value == "today") {
        handleTimePeriod({
          period: item.value,
          time: `${today} - ${today}`,
        });
      } else if (item.value == "yesterday") {
        handleTimePeriod({
          period: item.value,
          time: `${today} - ${yesterday}`,
        });
      } else if (item.value == "lastsevendays") {
        handleTimePeriod({
          period: item.value,
          time: lastsevendays,
        });
      } else if (item.value == "lastthirtydays") {
        handleTimePeriod({
          period: item.value,
          time: lastthirtydays,
        });
      } else if (item.value == "custom") {
        handleTimePeriod({
          period: item.value,
          time: `${today} - ${today}`,
        });
      } else {
        handleTimePeriod({
          period: item.value,
          time: "",
        });
      }
    }

    //close popup
    setAnchorElTime(null);
  };

  return (
    <Fragment>
      <div
        className={styles.filter_dropdown_title}
        onClick={(e) => setAnchorElTime(e.currentTarget)}
      >
        <span>{timeState}</span>
        <MdArrowDropDown className={styles.dropdown_icon} />
      </div>
      <Menu
        anchorEl={anchorElTime}
        open={openTime}
        onClose={() => setAnchorElTime(null)}
        classes={{
          paper: styles.activity_dropdown,
        }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        <li>
          <ul className={styles.time_dropdown_lists}>
            {timePeriods().map((item, i) => {
              return (
                <li
                  key={`${i + "timeData"}`}
                  className={styles.time_dropdown_list}
                  onClick={() => {
                    selectTimePriod(item);
                  }}
                >
                  <span className={styles.time_dropdown_first}>
                    {item.title}
                  </span>
                  <span className={styles.time_dropdown_last}>{item.time}</span>
                </li>
              );
            })}
          </ul>
        </li>
      </Menu>

      {timeState == "Custom Period" && (
        <DateRangeComponent
          name="time"
          value={value?.time ?? todayRange}
          setFieldValue={handleDateSelect}
        />
      )}
    </Fragment>
  );
};

export default TimePeriod;
